export const findNodeById = (treeData: any[], nodeId: any): any | null => {
  if (nodeId === undefined || nodeId === null || !Array.isArray(treeData)) {
    return null;
  }
  for (const element of treeData) {
    if (String(element.id) === String(nodeId)) {
      return element;
    }
    if (element?.children) {
      const found = findNodeById(element.children, nodeId);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

/**
 * After a folder is removed from the tree, keep the table on a node that
 * still exists: the previous folder if it survived, otherwise the nearest
 * remaining ancestor, otherwise root (null).
 */
export const resolveCurrentNodeAfterDelete = (
  savedNode: any,
  treeData: any[],
): any | null => {
  const stillThere = findNodeById(treeData, savedNode?.id);
  if (stillThere) {
    return stillThere;
  }
  let ancestor = savedNode?.parent;
  while (ancestor) {
    const found = findNodeById(treeData, ancestor.id);
    if (found) {
      return found;
    }
    ancestor = ancestor.parent;
  }
  return null;
};
